/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { BetsExpandCollapseContext, useBetsExpandCollapseContext } from '../../common/BetsExpandCollapseContext';
import ExpandedViewProvider from '../../common/ExpandedViewProvider';
import Loader from '../../common/Loader';
import { getAllAgg } from '../../data/utils/getAllAgg';
import { useFetchMatch } from '../../data/fetchMatch';
import { SeoContext } from '../../data/seo/SeoContextProvider';
import SeoMainContainer from '../../data/seo/SeoMainContainer';
import SeoMetaTags from '../../data/seo/SeoMetaTags';
import { useHandleSeoSettings } from '../../data/seo/seoUtils';
import { getConfiguration } from '../../data/utils/configuration';
import { getPrincipaleOPrimoGruppo } from '../../data/utils/getPrincipaleOPrimoGruppo';
import { getPrincipaleOPrimoMacroGruppo } from '../../data/utils/getPrincipaleOPrimoMacroGruppo';
import Match from './Match';
import MatchNavbar from './MatchNavbar';

export const MatchContext = React.createContext(null);

function filterBetsNotInBetGroup(bets, betGroup) {
    const mainGroupBets = new Set();
    betGroup.scommesse.forEach(bet =>  mainGroupBets.add(`${bet.id}_${bet.handicap}`));
    let compIds = [];
    Object.values(betGroup.compattate).forEach(ids => {
        compIds.push(ids.join('_'))
    });
    return bets.filter(bet => mainGroupBets.has(`${bet.id}_${bet.handicap}`) || compIds.includes(bet.id));
}

function MatchDataFetcher(props) {
    const conf = getConfiguration();
    const [betsExpandCollapseContext] = useBetsExpandCollapseContext();
    const seoContext = React.useContext(SeoContext);
    //const [seoSettingsState] = useFetchSeoSettings(seoContext.pathname,true,conf.seo);

    //useHandleSeoSettings(seoSettingsState);

    const firstRender = useRef(true);

    let initState = (() => {
        if (firstRender.current === true) {
            firstRender.current = false;
        } else {
            return;
        }

        let favorites = localStorage.getItem('favorite_markets');
        if (favorites != null) {
            favorites = JSON.parse(favorites);
        } else {
            favorites = {};
        }

        if (favorites[props.match.sportRef] !== undefined) {
            return {
                showLoader: true,
                data: null,
                matchFetch: props.match,
                match: null,
                macrogruppo: null,
                aggregata: null,
                macrogruppoFetch: null,
                aggregataFetch: getAllAgg(false, props.match.sportRef).idAggregata,
                landOnFavorites: true,
                setFavoritesAsSelected: true,
                favoritesSelected: false,
                favorites
            };
        } else {
            return {
                showLoader: true,
                data: null,
                matchFetch: props.match,
                match: null,
                macrogruppo: null,
                aggregata: null,
                macrogruppoFetch: null,
                aggregataFetch: props.match.openAggregata,
                landOnFavorites: false,
                setFavoritesAsSelected: false,
                favoritesSelected: false,
                favorites
            };
        }
    })();

    const [state, setState] = useState({
        ...initState,
        update(updt) {
            setState(prev => {
                return {...prev, ...updt};
            });
        },
        setShowLoader(showLoader) {
            this.update({showLoader});
        },
        setData(data) {
            let macrogruppo = this.macrogruppoFetch;
            if (macrogruppo == null) {
                macrogruppo = data.macrogruppi ? getPrincipaleOPrimoMacroGruppo(data.macrogruppi) : null
            }
            if (this.setFavoritesAsSelected) {
                const bets = data.bets;
                // I check whether there's any bets matching the favorite markets
                const favorites = bets.filter(bet => {
                    return this.isMarketFavorite(this.matchFetch.sportRef, bet.id + '_' + bet.handicap) && bet.hasOdds;
                });
                // If there are none, I show to the main bet group as selected by filtering only the bets that don't belong to it
                if (this.landOnFavorites && favorites.length === 0) {
                    const macrogruppo = data.macrogruppi.find(mg => mg.isPrincipale) || data.macrogruppi[0];
                    const mainBetGroup = getPrincipaleOPrimoGruppo(macrogruppo.aggregate);
                    mainBetGroup.scommesse = filterBetsNotInBetGroup(bets, mainBetGroup);
                    this.update({
                        showLoader: false,
                        data,
                        match: this.matchFetch,
                        macrogruppo,
                        aggregata: mainBetGroup.idAggregata,
                        landOnFavorites: false,
                        setFavoritesAsSelected: false,
                        favoritesSelected: false
                    });
                } else {
                    this.update({
                        showLoader: false,
                        data,
                        match: this.matchFetch,
                        macrogruppo,
                        aggregata: this.aggregataFetch,
                        landOnFavorites: false,
                        setFavoritesAsSelected: false,
                        favoritesSelected: true
                    });
                }
            } else {
                this.update({
                    showLoader: false,
                    data,
                    match: this.matchFetch,
                    macrogruppo,
                    aggregata: this.aggregataFetch,
                    landOnFavorites: false,
                    setFavoritesAsSelected: false,
                    favoritesSelected: false
                });
            }
        },
        changeMatch(matchFetch) {
            if (this.showFavoritesForSport(matchFetch.sportRef)) {
                const macrogruppoFetch = this.data.macrogruppi.find(mg => mg.id < 0);
                const aggregataFetch = getAllAgg(false, matchFetch.sportRef).idAggregata;
                this.update({
                    matchFetch,
                    macrogruppoFetch,
                    aggregataFetch,
                    landOnFavorites: true,
                    setFavoritesAsSelected: true
                });
            } else {
                this.update({
                    matchFetch,
                    macrogruppoFetch: null,
                    aggregataFetch: matchFetch.openAggregata
                });
            }
        },
        changeMacrogruppo(macrogruppoFetch) {
            if (macrogruppoFetch !== this.macrogruppo.id) {
                macrogruppoFetch = this.data.macrogruppi.find(mg => mg.id === macrogruppoFetch);
                const aggregataFetch = getPrincipaleOPrimoGruppo(macrogruppoFetch.aggregate).idAggregata;
                if (aggregataFetch !== this.aggregata) {
                    this.update({
                        macrogruppoFetch,
                        aggregataFetch
                    });
                } else {
                    this.update({
                        macrogruppo: macrogruppoFetch,
                        macrogruppoFetch
                    });
                }
            } else if (this.favoritesSelected) {
                const newBetGroupId = getPrincipaleOPrimoGruppo(this.macrogruppo.aggregate).idAggregata;
                const newBetGroup = this.data.gruppoById[newBetGroupId];
                newBetGroup.scommesse = filterBetsNotInBetGroup(this.data.bets, newBetGroup);
                this.update({
                    data: this.data,
                    aggregata: newBetGroup.idAggregata,
                    favoritesSelected: false
                });
            }
        },
        fetchData(aggregataFetch) {
            if (aggregataFetch !== this.aggregata) {
                this.update({aggregataFetch});
            }
        },
        favoriteMarketsOn() {
            const aggregataFetch = this.data.gruppiScommessa.find(ag => ag.idAggregata < 0).idAggregata;
            if (this.aggregataFetch !== aggregataFetch) {
                this.update({
                    aggregataFetch,
                    setFavoritesAsSelected: true
                });
            } else if (this.favoritesSelected === false) {
                this.update({favoritesSelected: true});
            }
        },
        favoriteMarketsOff() {
            this.update({favoritesSelected: false});
        },
        toggleFavorite(sportId, betId) {
            const favs = this.favorites;
            if (favs[sportId] === undefined) {
                favs[sportId] = {};
                favs[sportId][betId] = true;
            } else {
                if (favs[sportId][betId] === undefined) {
                    favs[sportId][betId] = true;
                } else {
                    delete favs[sportId][betId];
                    if (Object.keys(favs[sportId]).length === 0) {
                        delete favs[sportId];
                    }
                }
            }
            if (Object.keys(favs).length > 0) {
                if (favs[sportId] === undefined) {
                    const aggregataFetch = getPrincipaleOPrimoGruppo(this.macrogruppo.aggregate).idAggregata;
                    this.update({
                        favorites: {...favs},
                        favoritesSelected: false,
                        showLoader: true,
                        aggregataFetch
                    });
                } else {
                    this.update({favorites: {...favs}});
                }
                localStorage.setItem('favorite_markets', JSON.stringify(favs));
            } else {
                const aggregataFetch = getPrincipaleOPrimoGruppo(this.macrogruppo.aggregate).idAggregata;
                if (this.favoritesSelected) {
                    this.update({
                        favorites: {},
                        favoritesSelected: false,
                        showLoader: true,
                        aggregataFetch
                    });
                } else {
                    this.update({
                        favorites: {},
                        favoritesSelected: false
                    });
                }
                localStorage.removeItem('favorite_markets');
            }
        },
        showFavoritesForSport(sportId) {
            return this.favorites[sportId] !== undefined;
        },
        isMarketFavorite(sportId, betId) {
            return this.favorites[sportId] !== undefined && this.favorites[sportId][betId] !== undefined;
        }
    });
    const [reload, setReload] = useState(false);
    const [request] = useFetchMatch(state.matchFetch, state.aggregataFetch, false, reload, true);

    function reloadData() {
        setReload(!reload);
    }

    useEffect(() => {
        state.setShowLoader(true);
    }, [reload]);

    useEffect(() => {
        if (state.match != null) {
            state.changeMatch(props.match);
        }
    }, [props.match]);

    useEffect(() => {
        betsExpandCollapseContext.resetBetsCollapsed();
    }, [state.macrogruppoFetch, state.aggregataFetch]);

    useEffect(() => {
        let timeout = null;
        if (request.isLoading) {
            timeout = setTimeout(function() {
                state.setShowLoader(true);
            }, 100);
        } else {
            clearTimeout(timeout);
            if (!request.isError) {
                state.setData(request.data);
            }
        }

        return () => {
            clearTimeout(timeout);
        };
    }, [request]);

    if (state.showLoader) {
        return <Loader error={request.isError} />;
    }

    return (
        <MatchContext.Provider value={state}>
            <BetsExpandCollapseContext.Provider value={betsExpandCollapseContext}>
                <ExpandedViewProvider>
                    <MatchNavbar {...state.data}
                                match={props.match}
                                macrogruppo={state.macrogruppo}
                                aggregata={state.aggregata}
                                changeMacrogruppo={state.changeMacrogruppo.bind(state)}
                                changeAggregata={state.fetchData.bind(state)}
                                reloadData={reloadData} />
                    {state.showLoader || request.isError ?
                        <Loader error={request.isError} />
                        :
                        <>
                            <SeoMetaTags />
                            <Match {...state.match} {...state.data} aggregata={state.aggregata} />
                            <SeoMainContainer />
                        </>
                    }
                </ExpandedViewProvider>
            </BetsExpandCollapseContext.Provider>
        </MatchContext.Provider>
    );
}

export default MatchDataFetcher;